import * as React from "react"
import { type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"
import { tagVariants, getTagVariant } from "./tag-variants"

export interface TagProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof tagVariants> {}

function Tag({ className, variant, ...props }: TagProps) {
  return (
    <div className={cn(tagVariants({ variant }), className)} {...props} />
  )
}

// Smart Tag that automatically determines variant based on tag text
function SmartTag({ children, className, ...props }: Omit<TagProps, 'variant'>) {
  const tagText = typeof children === 'string' ? children : '';
  const variant = getTagVariant(tagText);
  
  return (
    <Tag className={className} variant={variant} {...props}>
      {children}
    </Tag>
  )
}

export { Tag, SmartTag, tagVariants }